module.exports = __webpack_public_path__ + "static/media/skyline.3579f69b.jpg";